import React from "react";
import {
  EditPopover,
  Panel,
  RangeNumberInput,
  SelectInput,
  ToggleInput,
} from "../input";
import { isUpdatedFromDefault } from "../utils";
import { isEmpty } from "lodash";

function MouseMovement({ block, actions, ...props }) {
  const {
    id,
    props: { mouseMovement = {} },
    dom,
  } = block;

  const { setProp } = actions;
  return (
    <>
      <Panel
        isUpdated={isUpdatedFromDefault([{ key: mouseMovement, default: {} }])}
        id={`block-setting-${id}-visibility`}
        title={"Mouse Movement"}
        initialOpen={false}
      >
        <ToggleInput
          value={mouseMovement?.onMouseMovement}
          onChange={(val) => {
            setProp((props) => {
              props.mouseMovement = {
                ...(mouseMovement ? mouseMovement : {}),
                onMouseMovement: val,
              };
            });
          }}
          label={"On Mouse Movement"}
        />
        {mouseMovement?.onMouseMovement && (
          <>
            <EditPopover
              contentWidth={"fit-content"}
              label={"2D Movement"}
              canReset={!isEmpty(mouseMovement?.movement2D)}
              onReset={() => {
                var temp = { ...mouseMovement };
                setProp((props) => {
                  props.mouseMovement = _.omit(temp, "movement2D");
                });
              }}
            >
              <SelectInput
                value={mouseMovement?.movement2D?.direction}
                onChange={(val) => {
                  setProp((props) => {
                    props.mouseMovement = {
                      ...(mouseMovement ? mouseMovement : {}),
                      movement2D: {
                        ...(mouseMovement?.movement2D
                          ? mouseMovement?.movement2D
                          : {}),
                        direction: val,
                      },
                    };
                  });
                }}
                label={"Direction"}
                options={[
                  {
                    label: "Opposite",
                    value: "opposite",
                  },
                  {
                    label: "Same",
                    value: "same",
                  },
                ]}
              />
              <RangeNumberInput
                min={0}
                max={100}
                step={1}
                value={mouseMovement?.movement2D?.displacement}
                onChange={(val) => {
                  setProp((props) => {
                    props.mouseMovement = {
                      ...(mouseMovement ? mouseMovement : {}),
                      movement2D: {
                        ...(mouseMovement?.movement2D
                          ? mouseMovement?.movement2D
                          : {}),
                        displacement: val,
                      },
                    };
                  });
                }}
                label={"Displacement"}
              />
            </EditPopover>
            <EditPopover
              contentWidth={"fit-content"}
              label={"3D Movement"}
              canReset={!isEmpty(mouseMovement?.movement3D)}
              onReset={() => {
                var temp = { ...mouseMovement };
                setProp((props) => {
                  props.mouseMovement = _.omit(temp, "movement3D");
                });
              }}
            >
              <SelectInput
                value={mouseMovement?.movement3D?.direction}
                onChange={(val) => {
                  setProp((props) => {
                    props.mouseMovement = {
                      ...(mouseMovement ? mouseMovement : {}),
                      movement3D: {
                        ...(mouseMovement?.movement3D
                          ? mouseMovement?.movement3D
                          : {}),
                        direction: val,
                      },
                    };
                  });
                }}
                label={"Direction"}
                options={[
                  {
                    label: "Opposite",
                    value: "opposite",
                  },
                  {
                    label: "Same",
                    value: "same",
                  },
                ]}
              />
              <RangeNumberInput
                min={0}
                max={100}
                step={1}
                value={mouseMovement?.movement3D?.displacement}
                onChange={(val) => {
                  setProp((props) => {
                    props.mouseMovement = {
                      ...(mouseMovement ? mouseMovement : {}),
                      movement3D: {
                        ...(mouseMovement?.movement3D
                          ? mouseMovement?.movement3D
                          : {}),
                        displacement: val,
                      },
                    };
                  });
                }}
                label={"Displacement"}
              />
            </EditPopover>
          </>
        )}
      </Panel>
    </>
  );
}

function transformProps(props, supportProps) {
  if (
    !isEmpty(props.mouseMovement) ||
    props.mouseMovement ||
    props.mouseMovement?.onMouseMovement ||
    props.mouseMovement?.movement2D?.direction ||
    props.mouseMovement?.movement2D?.displacement ||
    props.mouseMovement?.movement3D?.direction ||
    props.mouseMovement?.movement3D?.displacement
  ) {
    supportProps = {
      ...supportProps,
      className: {
        ...(supportProps.className ? supportProps.className : {}),
      },
      [`data-mousemovement-id`]: props.mouseMovement?.onMouseMovement
        ? props.id
        : undefined,
    };
  }
  return supportProps;
}

const supportSchema = {
  id: "grigora/mouse-movement",
  name: "MouseMovement",
  component: MouseMovement,
  transformProps: transformProps,
};

export default supportSchema;
